export const projects = [
  {
    id: 1,
    URLtitle: "adidas-messestand",
    title: "adidas Messestand",
    category: "Gestaltungen",
    projectName: "adidasMessestand",
    imageSrc: "/Gestaltungen/adidasmessestand/adidas1.png",
    detailsText: "",
  },
  {
    id: 2,
    URLtitle: "friedhof",
    title: "Friedhof",
    category: "Gestaltungen",
    projectName: "friedhof",
    imageSrc: "/Gestaltungen/Area/Friedhof/fh-1.JPG",
    detailsText:
      "Die Idee war es, einen Friedhof energiesparend, künstlerisch und lichtvoll zu gestalten. So schenken wir ihm Würde und Sinnlichkeit. Bei der Beleuchtung sind wir energiesparend vorgegangen und haben zum Großteil Solarleuchten (winterfähig) eingesetzt. Weiters haben wir mit Akku LED Spots mit einer geringen Wattleistung zur dezenten Ausleuchtung der Bäume und Gräber gearbeitet. So haben wir einen Friedhof in ein gigantisches, sinnliches und schönes Lichtermeer verwandelt, um den Besucher*innen abends ein einzigartiges Erlebnis zu ermöglichen.",
  },
  {
    id: 3,
    URLtitle: "halloween",
    title: "Halloween",
    category: "Gestaltungen",
    projectName: "halloween",
    imageSrc:
      "/Gestaltungen/Area/Halloween/f3ed56f6-445b-4f8b-9c0c-d0742371fbf2.JPG",
    detailsText:
      "Die „Gruseltage“ von Podersdorf (Burgenland) waren eine einzigartige Inszenierung und wurden zu einem Jahreshighlight im Osten Österreichs, am Neusiedlersee. Wir haben hier verschiedene Stationen für Kinder gebaut, welche zur Vergnügung da waren. Darunter waren Grusel Landschaften, welche sich auf Spinnen, Geister, ein Gruselkino, Fledermäuse, Labyrinth und einen Freidhof fokussierten. Die gesamte Inszenierung, inklusive Bäume, wurde von uns in verschiedenen Farben beleuchtet. So konnten die Kinder mit ihren Familien in eine Gruselwelt eintauchen und erlebten unvergessliche Momente. Insgesamt besuchten über 8.000 Menschen die Halloween Gruseltage in Podersdorf.",
  },
  {
    id: 4,
    URLtitle: "schalke",
    title: "Schalke",
    category: "Gestaltungen",
    projectName: "schalke",
    imageSrc: "/Gestaltungen/Area/Schalke/logo m boden u tribuehne.jpg",
    detailsText:
      "Wir projizierten mit sechs PANI-Projektoren den gesamten Zuschauerraum und das Spielfeld des Stadions auf Schalke an. Zu hören war internationaler Fangesang, welchen wir mittels Stadionbeschallung abspielten. Die Besucher*innen hatten den Eindruck, als wäre das Stadion voll besetzt. Weiters bauten wir zwischen dem Rasen und den Tribünen ein 60.000 Liter Wasserbecken auf, um eine Wasserwand mit einer Breite von 45m und einer Höhe von 20m entstehen zu lassen, worauf wir mittels Videobeamer das „Making of the Logo“ zeigten.",
  },
  {
    id: 5,
    URLtitle: "weihnachtsmaerkte",
    title: "Weihnachtsmärkte",
    category: "Gestaltungen",
    projectName: "weihweihnachtsmaerkte",
    imageSrc: "/Gestaltungen/Area/Weihnachtsmaerkte/sternenkino foto.jpg",
    detailsText:
      "Wir beschäftigen uns seit vielen Jahren mit der Gestaltung von Weihnachtsmärkten. Besonders beliebt ist unser Sternenkino, welches sich in einem riesigen Geschenkpaket befindet, das wir bauen und verkleiden. Die Kinder können außen ihre Weihnachtswünsche auf das Paket schreiben und innen ein unvergessliches Kino erleben, wo wir Kinder-Weihnachtsfilme zeigen. Weiters setzen wir kraftvolle Lichtspiele und sinnliche Beleuchtungen am gesamten Platz ein.",
  },
  {
    id: 6,
    URLtitle: "baustellen",
    title: "Baustellen",
    category: "Gestaltungen",
    projectName: "baustellen",
    imageSrc:
      "/Gestaltungen/Baustellen/Bildschirmfoto 2022-10-14 um 12.15.07.png",
    detailsText:
      "In den vergangenen Jahren haben wir unseren Fokus auf Baustellengestaltung erweitert. Wir verkleiden Krane, Absperrungen, Gitter und Baustellen mit Bannern den Logos unserer Kunden, Kunst und Botschaften. So gestalten wir ein einzigartiges, kunstvolles Erscheinungsbild einer Baustelle.",
  },
  {
    id: 7,
    URLtitle: "container",
    title: "Container",
    category: "Gestaltungen",
    projectName: "container",
    imageSrc: "/Gestaltungen/Container/IMG_1189.jpeg",
    detailsText:
      "Vor ein paar Jahren kam bei uns die Containergestaltung hinzu. Wir bauen Konstruktionen wie Bühnen für Festivals, Kunst-Installationen und Stände für Messen mittels Container. Unsere Aufgabe ist es, neue und leichte Ansätze für unsere Kund*innen zu finden Konstruktionen zu bauen, welche uns mittels Container zur Gänze gelingen.",
  },
  {
    id: 8,
    URLtitle: "clam",
    title: "Clam",
    category: "Gestaltungen",
    projectName: "clam",
    imageSrc:
      "/Gestaltungen/Konzerte_Festivals/Clam/16bd2418-c7aa-4d07-a31c-6012a9a37e3f.jpg",
    detailsText: "",
  },
  {
    id: 9,
    URLtitle: "frequency",
    title: "Frequency",
    category: "Gestaltungen",
    projectName: "frequency",
    imageSrc:
      "/Gestaltungen/Konzerte_Festivals/Frequency/Bildschirmfoto 2022-10-14 um 12.18.37.png",
    detailsText: "",
  },
  {
    id: 10,
    URLtitle: "novarock",
    title: "Nova Rock",
    category: "Gestaltungen",
    projectName: "novaRock",
    imageSrc:
      "/Gestaltungen/Konzerte_Festivals/Nova Rock/Bildschirmfoto 2022-10-14 um 12.31.25.png",
    detailsText: "",
  },
  {
    id: 11,
    URLtitle: "streetart",
    title: "Streetart",
    category: "Gestaltungen",
    projectName: "streetart",
    imageSrc: "/Gestaltungen/Streetart/Streetartist Aktion 2.png",
    detailsText: "",
  },
  {
    id: 12,
    URLtitle: "ballon-kegel",
    projectName: "ballonKegel",
    title: "Ballon-Kegel",
    category: "Licht",
    projectName: "ballonKegel",
    imageSrc: "/Licht/ballon_kegel/bk-1_1.jpg",
    detailsText:
      "Wir verwenden Leuchtballons mit bis zu sieben Meter Durchmesser. In den Ballons befindet sich ein Leuchtsockel, der mit vier Leuchtmittel von jeweils 650W bestückt werden kann. Die Ballons werden mit Luft oder Helium gefüllt und sind dementsprechend in der Lage Fahnen, Dekorationselemente oder auch Menschen mit einem Gewicht von maximal 80kg (bei 7m Durchmesser) ohne Probleme zu tragen. Die Einsatzmöglichkeiten der Ballons sind vielfältig, sei es als Beleuchtungs- oder Dekorationselement, als Bauteil von Installationen oder als bedruckter Informationsträger.",
  },
  {
    id: 13,
    URLtitle: "drohnenschow",
    title: "Drohnenschow",
    category: "Licht",
    projectName: "drohnenshow",
    imageSrc: "/Licht/Drohnenshow/Drohnenshow.png",
    detailsText: "",
  },
  {
    id: 14,
    URLtitle: "feuerschalen",
    title: "Feuerschalen",
    category: "Licht",
    projectName: "feuerschalen",
    imageSrc: "/Licht/feuerschalen/fs-4.jpg",
    detailsText: "",
  },
  {
    id: 15,
    URLtitle: "lichterketten",
    title: "Lichterketten",
    category: "Licht",
    projectName: "lichterketten",
    imageSrc: "/Licht/Lichterketten/lk-1.png",
    detailsText:
      "Wir spezialisieren uns bei Gestaltungen von Events meist auf unsere bekannten Lichterketten. Wir stellen unsere Lichterketten selbst her, mit der gewünschten Länge und Anzahl der Glühbirnen Hierbei hängen wir Lichterketten je nach Vorgabe umweltbewusst in Bäume, auf Hängevorrichtungen oder an Zäune. So schaffen wir ein schönes Ambiente und beleuchten Gehwege, Durchgänge oder Sonstiges.",
  },
  {
    id: 16,
    URLtitle: "mapping",
    title: "Mapping",
    category: "Projektionen",
    projectName: "mapping",
    imageSrc: "/Projektionen/Mapping/mapping1.jpg",
    detailsText: "",
  },
  {
    id: 17,
    URLtitle: "mobile-projektionen",
    title: "Mobile Projektionen",
    category: "Projektionen",
    projectName: "mobileProjektionen",
    imageSrc:
      "/Projektionen/MobileProjektionen/mobile Projektionstour Luzern 3.png",
    detailsText:
      "Eine unserer Hauptsparten sind unsere sehr beliebten mobilen Projektionen. Wir haben hierzu viel Erfahrung, da wir diese Form der Projektion schon seit vielen Jahren umsetzen. Hierzu packen wir in unseren Transporter ein Aggregat, Abspielgeräte und natürlich unsere Hochleistungsprojektoren und gehen auf Tour und projizieren auf Gebäude, Fassaden und Objekte. Wir können auch während der Fahrt rausprojizieren, welches sehr beeindruckend und auffällig ist.",
  },
  {
    id: 18,
    URLtitle: "weitere-projektionen",
    title: "Weitere",
    category: "Projektionen",
    projectName: "weitereProjektionen",
    imageSrc: "/Projektionen/Projektion Michaelerplatz Wien.png",
    detailsText: "",
  },
  {
    id: 19,
    URLtitle: "adventkalender",
    title: "Adventkalender",
    category: "Sonderkonstruktionen",
    projectName: "adventkalender",
    imageSrc: "/Sonderkonstruktionen/Adventkalender/1.png",
    detailsText:
      "Hierbei war die Anforderung, den größten Rubbellos-Adventkalender der Welt zu bauen, auf welchen man wie bei einem richtigen Rubbellos einzelnen Felder mit einer riesigen Münze aufrubbeln konnte um Preise zu gewinnen. All das für die österreichischen Lotterien.",
  },
  {
    id: 20,
    URLtitle: "handgolfbahn",
    title: "Handgolfbahn",
    category: "Sonderkonstruktionen",
    projectName: "handgolfbahn",
    imageSrc: "/Sonderkonstruktionen/Handgolfbahn/Golfbahn.png",
    detailsText:
      "Wir wollen mit den Bahnen versuchen, nicht nur Geschicklichkeit zu fördern, sondern auch die Intelligenz, in dem die Spielenden auch überlegen müssen, wie sie vorgehen, welche Bälle sie verwenden, welche Strategien sie anwenden, und wie sie am besten und gut überlegt, zu den höchsten Punkten kommen. Es ist eine spezielle Form des bekannten Minigolfs, aber abgewandelt, so dass man die Bälle per Hand ins Ziel werfen muss. So haben wir eine neue Art des Golfs kreiert, welche einzigartig ist.",
  },
  {
    id: 21,
    URLtitle: "kunstaktion-graz",
    title: "Kunstaktion Graz",
    category: "Sonderkonstruktionen",
    projectName: "kunstaktionGraz",
    imageSrc:
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.43.42.png",
    detailsText: "",
  },
  {
    id: 22,
    URLtitle: "milka",
    title: "Milka",
    category: "Sonderkonstruktionen",
    projectName: "milka",
    imageSrc:
      "/Sonderkonstruktionen/Milka/Bildschirmfoto 2020-05-26 um 14.54.43.png",
    detailsText:
      "Wir entwickelten, plante und bauten aus GFK und Steinmehl riesige Hasenohren, welche in der Spree (direkt beim Molecule Mann), dem Main und dem Donaukanal „geschwommen“ sind, oder in Hamburg auf einem 30m hohen Dach platziert wurden. Weiters bauten wir 3D Hasenpfoten, welche wir auf Hausmauern in Berlin und Wien hängten.",
  },
  {
    id: 23,
    URLtitle: "blue-morpho",
    title: "Blue Morpho",
    category: "Sonderkonstruktionen",
    projectName: "blueMorpho",
    imageSrc: "/Sonderkonstruktionen/Schmetterling/1.jpeg",
    detailsText:
      "Hierbei entwickelten, planten und bauten wir für einen Handyhersteller den höchstwahrscheinlich größten Schmetterling der Welt. Alles ohne Logo und als Kunstsponsoringprojekt mit Social Media Auftritten. 14m Groß, mit Unterkonstruktionen insgesamt 30 Tonnen schwer, einem 261 Seiten Statikgutachten und alles direkt vor dem MuseumsQuartier in Wien mit tausenden Fotos pro Tag.",
  },
  {
    id: 24,
    URLtitle: "weiteresonderkonstruktionen",
    title: "Weitere",
    category: "Sonderkonstruktionen",
    projectName: "weitereSonderkonstruktionen",
    imageSrc: "/Sonderkonstruktionen/Weitere/Zalando Wand.png",
    detailsText: "",
  },
  {
    id: 25,
    URLtitle: "glaskugel",
    title: "Glaskugel",
    category: "Wasser",
    projectName: "glaskugel",
    imageSrc: "/Wasser/Glaskugel/gk1.jpg",
    detailsText:
      "Mit der mit Wasser befüllten Glaskugel haben wir ein weiteres Projektionsmedium geschaffen, das dem/der Betrachter/in eine vollkommen neue Optik bietet. Gerne gestalten wir Ihren Bedürfnissen angepasste, individuell gestaltete Glaskugelsäulen aus verschiedensten Materialien und Werkstoffen.",
  },
  {
    id: 26,
    URLtitle: "springbrunnen",
    title: "Springbrunnen",
    category: "Wasser",
    projectName: "springbrunnen",
    imageSrc: "/Wasser/Springbrunnen/3.jpg",
    detailsText:
      "Wir haben einen bestehenden mobilen Springbrunnen der allen Anforderungen Entspricht. Er kann ganz einfach befüllt und überall hin gerollt werden.Die Oberfläche besteht aus einem rostfreiem Edelstahlgewebe. In der Mitte und unterhalb des Edelstahlgewebes und nicht sichtbar, befindet sich ein Gitter damit das Wasser wieder in das Becken zurückfließen kann. Das Becken wird je nach Wunsch gestaltet. Seitlich kann es dem Projekt und dem Kunden entsprechend beklebt werden. Es befinden sich 30 Düsen oval angelegt im Brunnen. Je nach Wunsch können diese im Vorfeld verringert und in der Höhe reguliert werden.",
  },
  {
    id: 27,
    URLtitle: "wassershow",
    title: "Wassershow",
    category: "Wasser",
    projectName: "wassershow",
    imageSrc: "/Wasser/Wassershow/Wasserfall Large.jpeg",
    detailsText:
      "Wassershows sind beeindruckende Wasserskulpturen die von uns individuell, auf Ihre Bedürfnisse angepasst, geplant und angefertigt werden. Je nach Situation sind unterschiedliche Dimensionen der Pumpen, Fontänen und Steuerungs- bzw. Schalteinheit notwendig, um den entsprechenden Effekt zu erzielen.",
  },
  {
    id: 28,
    URLtitle: "wasservorhang",
    title: "Wasservorhang",
    category: "Wasser",
    projectName: "wasservorhang",
    imageSrc: "/Wasser/Wasservorhang/wv-3.png",
    detailsText:
      "Ein Wasservorhang ist nicht nur eine Erfrischung für das Auge, auch die umgebende Luft wird vom herabfallenden Element von Staub gereinigt und gekühlt. Der Wasservorhang ist individuell einsetzbar und beinahe wartungsfrei. Der Wasservorhang ist eine, mit bis zu drei Reihen Düsen ausgestattete Düsenleiste, welche je nach Länge von einer oder mehreren Pumpen mit Wasser versorgt wird.",
  },
  {
    id: 29,
    URLtitle: "wasserwand",
    title: "Wasserwand",
    category: "Wasser",
    projectName: "wasserwand",
    imageSrc: "/Wasser/Wasserwand/ww-2.jpg",
    detailsText:
      "Die Wasserwand kann grundsätzlich überall eingesetzt werden wo ausreichend Wasser vorhanden ist. Entweder in einem Wasserbecken oder in stehenden und fließenden Gewässern. Es ist ebenfalls möglich, das gesamte System mobil umzusetzen, indem die Pumpe, das Aggregat und das Projektionsgehäuse auf ein Schiff montiert wird. Natürlich lassen sich eine oder mehrere Wasserwände mit Fontänen und Wasserspielen zu Installationen verbinden. Durch eigens entwickelte Hochleistungspumpen kann eine Höhe von bis zu 20 Metern und eine Breite von 40 Metern erreicht werden.",
  },
  {
    id: 30,
    URLtitle: "lichterweg",
    title: "Lichterweg Podersdorf",
    category: "Licht",
    projectName: "lichterweg",
    imageSrc: "/Licht/Lichterweg/IMG_8417.jpg",
    detailsText: "",
  },
];

export const images = {
  Gestaltungen: {
    adidasMessestand: [
      "/Gestaltungen/adidasmessestand/adidas1.png",
      "/Gestaltungen/adidasmessestand/adidas2.png",
      "/Gestaltungen/adidasmessestand/adidas3.png",
      "/Gestaltungen/adidasmessestand/adidas4.png",
      "/Gestaltungen/adidasmessestand/adidas5.png",
      "/Gestaltungen/adidasmessestand/adidas6.png",
      "/Gestaltungen/adidasmessestand/adidas7.png",
      "/Gestaltungen/adidasmessestand/adidas8.png",
      "/Gestaltungen/adidasmessestand/adidas9.png",
      "/Gestaltungen/adidasmessestand/adidas10.png",
      "/Gestaltungen/adidasmessestand/adidas11.png",
      "/Gestaltungen/adidasmessestand/adidas12.png",
      "/Gestaltungen/adidasmessestand/adidas13.png",
      "/Gestaltungen/adidasmessestand/adidas14.png",
    ],
    friedhof: [
      "/Gestaltungen/Area/Friedhof/fh-1.JPG",
      "/Gestaltungen/Area/Friedhof/fh-2.JPG",
      "/Gestaltungen/Area/Friedhof/fh-3.JPG",
      "/Gestaltungen/Area/Friedhof/fh-4.png",
      "/Gestaltungen/Area/Friedhof/fh-5.png",
      "/Gestaltungen/Area/Friedhof/fh-6.png",
      "/Gestaltungen/Area/Friedhof/fh-7.png",
      "/Gestaltungen/Area/Friedhof/fh-8.png",
      "/Gestaltungen/Area/Friedhof/fh-9.jpeg",
      "/Gestaltungen/Area/Friedhof/fh-10.png",
      "/Gestaltungen/Area/Friedhof/fh-11.JPG",
      "/Gestaltungen/Area/Friedhof/fh-12.JPG",
      "/Gestaltungen/Area/Friedhof/fh-13.JPG",
    ],
    halloween: [
      "/Gestaltungen/Area/Halloween/1.jpg",
      "/Gestaltungen/Area/Halloween/1c0ddac7-e045-47db-9999-2dba86df751d.JPG",
      "/Gestaltungen/Area/Halloween/3e90ab27-170b-4839-b5e9-cc4298eddf5a.JPG",
      "/Gestaltungen/Area/Halloween/8ef1eda0-ecd9-42af-94b7-5219416b0bb4.JPG",
      "/Gestaltungen/Area/Halloween/9bdb4f10-2560-4f54-b1c2-a11936ef8af3.JPG",
      "/Gestaltungen/Area/Halloween/9f775a55-8473-4be9-8135-5a2381be0bd9.JPG",
      "/Gestaltungen/Area/Halloween/13c8a238-62a3-4789-8c37-fa3661771046.JPG",
      "/Gestaltungen/Area/Halloween/64e21de2-2545-4e58-ab2e-d875b07251de.JPG",
      "/Gestaltungen/Area/Halloween/65fbb4e8-ce0c-41e9-bb67-11fe4adcca83.JPG",
      "/Gestaltungen/Area/Halloween/73d00f2b-ac82-4e2a-aa4e-b435c4b850d7.JPG",
      "/Gestaltungen/Area/Halloween/101d1d43-bc79-46ef-8d2b-7368b4d4d7c4.JPG",
      "/Gestaltungen/Area/Halloween/143df997-b5f4-43e8-8cbf-faadda66334e.jpg",
      "/Gestaltungen/Area/Halloween/0272d93c-e973-462a-bf66-57cfa91e3c87.JPG",
      "/Gestaltungen/Area/Halloween/715f6223-2c1f-45a1-96b1-42f7ec224ff9.JPG",
      "/Gestaltungen/Area/Halloween/1378aade-d201-4a95-b378-ff580c089540.JPG",
      "/Gestaltungen/Area/Halloween/584539e1-1b34-4d31-b5ff-83ab95f449d0.JPG",
      "/Gestaltungen/Area/Halloween/02149057-97bc-497c-bc2b-cf1fe0a557d9.jpg",
      "/Gestaltungen/Area/Halloween/b8d832b4-a575-4636-aa82-b1804b305bac.JPG",
      "/Gestaltungen/Area/Halloween/b8e69da5-f466-4d5d-b5ce-17a75b8fc668.jpg",
      "/Gestaltungen/Area/Halloween/c619c7d3-b665-4aa7-9dab-c3b992e0f77d.jpg",
      "/Gestaltungen/Area/Halloween/c2846c7d-d56c-4453-8bf3-b668de115893.JPG",
      "/Gestaltungen/Area/Halloween/d1cea70b-26bb-40a0-8393-77a6d1e3346e.JPG",
      "/Gestaltungen/Area/Halloween/d514391e-42ad-4de9-b75f-39e6ed1cc5f0.JPG",
      "/Gestaltungen/Area/Halloween/f3ed56f6-445b-4f8b-9c0c-d0742371fbf2.JPG",
    ],
    schalke: [
      "/Gestaltungen/Area/Schalke/logo m boden u tribuehne.jpg",
      "/Gestaltungen/Area/Schalke/Bildschirmfoto 2024-10-01 um 17.46.58.png",
      "/Gestaltungen/Area/Schalke/Bildschirmfoto 2024-10-01 um 17.47.15.png",
      "/Gestaltungen/Area/Schalke/Fußball WM 2006.png",
      "/Gestaltungen/Area/Schalke/schalk3.jpg",
    ],
    weihnachtsmaerkte: [
      "/Gestaltungen/Area/Weihnachtsmaerkte/6f154b23-572e-43bb-937e-0ca8144252c7.JPG",
      "/Gestaltungen/Area/Weihnachtsmaerkte/38bc55e1-7856-40fb-b1af-987d16103c1a.JPG",
      "/Gestaltungen/Area/Weihnachtsmaerkte/96d2f384-9fba-4dc9-9857-6ebc5637b0b0.JPG",
      "/Gestaltungen/Area/Weihnachtsmaerkte/582d5cdb-5eeb-4d2e-b577-d382cee74c9b.JPG",
      "/Gestaltungen/Area/Weihnachtsmaerkte/Bildschirmfoto 2022-10-14 um 12.58.41.png",
      "/Gestaltungen/Area/Weihnachtsmaerkte/dcf28314-1766-4498-a598-b800852cba39.JPG",
      "/Gestaltungen/Area/Weihnachtsmaerkte/DSC_7990.JPG",
      "/Gestaltungen/Area/Weihnachtsmaerkte/IMG_3506.jpg",
      "/Gestaltungen/Area/Weihnachtsmaerkte/sternenkino foto.jpg",
    ],
    baustellen: [
      "/Gestaltungen/Baustellen/1.png",
      "/Gestaltungen/Baustellen/2.png",
      "/Gestaltungen/Baustellen/3.png",
      "/Gestaltungen/Baustellen/4.png",
      "/Gestaltungen/Baustellen/5.png",
      "/Gestaltungen/Baustellen/6.png",
      "/Gestaltungen/Baustellen/7.png",
      "/Gestaltungen/Baustellen/8.png",
      "/Gestaltungen/Baustellen/9.png",
      "/Gestaltungen/Baustellen/Bildschirmfoto 2022-10-14 um 12.15.07.png",
      "/Gestaltungen/Baustellen/11.png",
      "/Gestaltungen/Baustellen/12.png",
      "/Gestaltungen/Baustellen/13.png",
      "/Gestaltungen/Baustellen/14.png",
      "/Gestaltungen/Baustellen/15.png",
      "/Gestaltungen/Baustellen/16.png",
      "/Gestaltungen/Baustellen/17.png",
      "/Gestaltungen/Baustellen/18.png",
      "/Gestaltungen/Baustellen/19.png",
      "/Gestaltungen/Baustellen/20.png",
      "/Gestaltungen/Baustellen/21.png",
      "/Gestaltungen/Baustellen/22.png",
      "/Gestaltungen/Baustellen/23.png",
      "/Gestaltungen/Baustellen/24.png",
    ],
    container: [
      "/Gestaltungen/Container/Container Begrünung Alpenland.png",
      "/Gestaltungen/Container/Container Begrünung Raika .png",
      "/Gestaltungen/Container/Container Gestaltung ArtInstallation.png",
      "/Gestaltungen/Container/Container Gestaltung Artinszenierung 2.png",
      "/Gestaltungen/Container/Container Installation Frequency.png",
      "/Gestaltungen/Container/Container Installation G3.jpg",
      "/Gestaltungen/Container/Container Installation Nova Rock.png",
      "/Gestaltungen/Container/Container Installation StreetArt.png",
      "/Gestaltungen/Container/Containerverkleidung Banner.png",
      "/Gestaltungen/Container/Containerverkleidung Green.png",
      "/Gestaltungen/Container/IMG_1189.jpeg",
      "/Gestaltungen/Container/IMG_1191.jpeg",
      "/Gestaltungen/Container/IMG_1192.jpeg",
      "/Gestaltungen/Container/IMG_1195.jpeg",
      "/Gestaltungen/Container/IMG_1199.jpeg",
    ],
    clam: [
      "/Gestaltungen/Konzerte_Festivals/Clam/6dc2718b-6c98-4220-a049-f5b076e9d49b.JPG",
      "/Gestaltungen/Konzerte_Festivals/Clam/16bd2418-c7aa-4d07-a31c-6012a9a37e3f.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/98ad98eb-8e42-4d03-af98-9bd182eced85.JPG",
      "/Gestaltungen/Konzerte_Festivals/Clam/439fed4a-b35f-419a-bbe9-4bb752bba596.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/9361402d-9408-42a7-bc3c-52917652f7d4.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/10209540-fbae-466c-935d-6cf6bab7d005.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/24574204-c061-4a30-91a6-b7efbf11dfac.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/29808640-d5d6-46b3-839d-4e2d57be3423.JPG",
      "/Gestaltungen/Konzerte_Festivals/Clam/bd772aad-e5b2-4320-b129-cc0801113684.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/Bildschirmfoto 2017-07-30 um 17.12.44.png",
      "/Gestaltungen/Konzerte_Festivals/Clam/Bildschirmfoto 2022-10-14 um 12.21.45.png",
      "/Gestaltungen/Konzerte_Festivals/Clam/Bildschirmfoto 2022-10-14 um 12.29.40.png",
      "/Gestaltungen/Konzerte_Festivals/Clam/Bildschirmfoto 2022-10-14 um 12.30.45.png",
      "/Gestaltungen/Konzerte_Festivals/Clam/burg clam sting.png",
      "/Gestaltungen/Konzerte_Festivals/Clam/IMG_6157.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/IMG_6197.jpg",
      "/Gestaltungen/Konzerte_Festivals/Clam/IMG_6208.jpg",
    ],
    frequency: [
      "/Gestaltungen/Konzerte_Festivals/Frequency/0ce034ea-a4f5-4b39-a5de-a4dc1b4413cf.JPG",
      "/Gestaltungen/Konzerte_Festivals/Frequency/6f79301d-2167-4860-8e82-f702640cf271.JPG",
      "/Gestaltungen/Konzerte_Festivals/Frequency/25b83637-9377-4b17-8a27-9f163dcdf9a7.JPG",
      "/Gestaltungen/Konzerte_Festivals/Frequency/14892258-eee4-45d7-a19e-616e1d71009d.JPG",
      "/Gestaltungen/Konzerte_Festivals/Frequency/Bildschirmfoto 2022-10-14 um 12.18.37.png",
      "/Gestaltungen/Konzerte_Festivals/Frequency/Bildschirmfoto 2022-10-14 um 12.18.46.png",
      "/Gestaltungen/Konzerte_Festivals/Frequency/Bildschirmfoto 2022-10-14 um 12.19.39.png",
      "/Gestaltungen/Konzerte_Festivals/Frequency/Bildschirmfoto 2022-10-14 um 12.19.56.png",
      "/Gestaltungen/Konzerte_Festivals/Frequency/Bildschirmfoto 2022-10-14 um 12.20.15.png",
      "/Gestaltungen/Konzerte_Festivals/Frequency/d680ab3f-dda0-4df3-8425-8734944fffa7.JPG",
      "/Gestaltungen/Konzerte_Festivals/Frequency/fdac3506-d15b-42d6-ac34-164a12fd9195.JPG",
    ],
    novaRock: [
      "/Gestaltungen/Konzerte_Festivals/Nova Rock/begehbarer Wasservorhang NR.png",
      "/Gestaltungen/Konzerte_Festivals/Nova Rock/begehbarer Wasservorhang.png",
      "/Gestaltungen/Konzerte_Festivals/Nova Rock/Bildschirmfoto 2022-10-14 um 12.31.25.png",
    ],
    streetart: [
      "/Gestaltungen/Streetart/Streetartist Aktion 2.png",
      "/Gestaltungen/Streetart/Streetartist Aktion 3.png",
      "/Gestaltungen/Streetart/Streetartist Aktion 4.png",
      "/Gestaltungen/Streetart/Streetartist Aktion 6.png",
      "/Gestaltungen/Streetart/Streetartist Aktion.png",
    ],
  },
  Licht: {
    ballonKegel: [
      "/Licht/ballon_kegel/bk-1_1.jpg",
      "/Licht/ballon_kegel/bk-1.png",
      "/Licht/ballon_kegel/bk-2.png",
      "/Licht/ballon_kegel/bk-3.jpg",
      "/Licht/ballon_kegel/bk-4.JPG",
      "/Licht/ballon_kegel/bk-5.jpg",
      "/Licht/ballon_kegel/bk-6.png",
      "/Licht/ballon_kegel/bk-7.png",
      "/Licht/ballon_kegel/bk-8.JPG",
      "/Licht/ballon_kegel/bk-9.jpg",
      "/Licht/ballon_kegel/bk-10.jpg",
      "/Licht/ballon_kegel/bk-11.jpg",
    ],
    drohnenshow: [
      "/Licht/Drohnenshow/Drohnenshow 2.png",
      "/Licht/Drohnenshow/Drohnenshow.png",
    ],
    feuerschalen: [
      "/Licht/feuerschalen/fs-1.jpg",
      "/Licht/feuerschalen/fs-2.jpeg",
      "/Licht/feuerschalen/fs-3.jpg",
      "/Licht/feuerschalen/fs-4.jpg",
      "/Licht/feuerschalen/fs-5.png",
      "/Licht/feuerschalen/fs-6.jpg",
      "/Licht/feuerschalen/fs-7.png",
      "/Licht/feuerschalen/fs-8.jpg",
    ],
    lichterketten: [
      "/Licht/Lichterketten/lk-1.png",
      "/Licht/Lichterketten/lk-2.png",
      "/Licht/Lichterketten/lk-3.JPG",
      "/Licht/Lichterketten/lk-4.JPG",
      "/Licht/Lichterketten/lk-5.JPG",
      "/Licht/Lichterketten/lk-6.png",
      "/Licht/Lichterketten/lk-7.png",
      "/Licht/Lichterketten/lk-8.png",
    ],
    lichterweg: [
      "/Licht/Lichterweg/IMG_8413.jpg",
      "/Licht/Lichterweg/IMG_8414.jpg",
      "/Licht/Lichterweg/IMG_8415.jpg",
      "/Licht/Lichterweg/IMG_8416.jpg",
      "/Licht/Lichterweg/IMG_8417.jpg",
      "/Licht/Lichterweg/IMG_8418.jpg",
    ],
  },
  Projektionen: {
    mapping: [
      "/Projektionen/Mapping/Mapping Kiev 2.png",
      "/Projektionen/Mapping/Mapping Kiev 3.png",
      "/Projektionen/Mapping/Mapping Kiev 4.png",
      "/Projektionen/Mapping/Mapping Kiev 5.png",
      "/Projektionen/Mapping/Mapping Kiev 6.png",
      "/Projektionen/Mapping/Mapping Kiev.png",
      "/Projektionen/Mapping/Mapping Rathaus 2.png",
      "/Projektionen/Mapping/Mapping Rathaus 3.png",
      "/Projektionen/Mapping/Mapping Rathaus 4.png",
      "/Projektionen/Mapping/Mapping Rathaus.png",
      "/Projektionen/Mapping/Mapping spk 2.png",
      "/Projektionen/Mapping/Mapping spk.png",
      "/Projektionen/Mapping/mapping1.jpg",
    ],
    mobileProjektionen: [
      "/Projektionen/MobileProjektionen/mobile Projektionstour Lausanne .png",
      "/Projektionen/MobileProjektionen/mobile Projektionstour Luzern 2.png",
      "/Projektionen/MobileProjektionen/mobile Projektionstour Luzern 3.png",
      "/Projektionen/MobileProjektionen/mobile Projektionstour Luzern 4.png",
      "/Projektionen/MobileProjektionen/mobile Projektionstour Luzern.png",
    ],
    weitereProjektionen: [
      "/Projektionen/pj-1.png",
      "/Projektionen/pj-2.png",
      "/Projektionen/pj-4.png",
      "/Projektionen/pj-5.png",
      "/Projektionen/pj-6.png",
      "/Projektionen/pj-7.png",
      "/Projektionen/pj-8.jpg",
      "/Projektionen/pj-9.jpg",
      "/Projektionen/pj-10.JPG",
      "/Projektionen/pj-11.JPG",
      "/Projektionen/pj-13.JPG",
      "/Projektionen/pj14.jpg",
      "/Projektionen/Projektiongroß",
      "/Projektionen/Projektion Burg Clam.png",
      "/Projektionen/Projektion Michaelerplatz Wien.png",
      "/Projektionen/Projektion Uno Greenpeace 2.png",
      "/Projektionen/Projektion Uno Greenpeace.png",
      "/Projektionen/Projektionen Felsen Burg Aggstein.jpg",
      "/Projektionen/rathaus stp.jpg",
      "/Projektionen/salzburg10_2.JPG",
      "/Projektionen/Schneeprojektion art.png",
      "/Projektionen/WasserprojektionGraz.png",
    ],
  },
  Sonderkonstruktionen: {
    adventkalender: [
      "/Sonderkonstruktionen/Adventkalender/1.png",
      "/Sonderkonstruktionen/Adventkalender/2.png",
      "/Sonderkonstruktionen/Adventkalender/3.png",
      "/Sonderkonstruktionen/Adventkalender/4.png",
      "/Sonderkonstruktionen/Adventkalender/5.png",
      "/Sonderkonstruktionen/Adventkalender/6.png",
    ],
    handgolfbahn: [
      "/Sonderkonstruktionen/Handgolfbahn/Golfbahn.png",
      "/Sonderkonstruktionen/Handgolfbahn/Bildschirmfoto 2024-01-26 um 22.43.15.png",
      "/Sonderkonstruktionen/Handgolfbahn/Bildschirmfoto 2024-01-26 um 22.43.29.png",
      "/Sonderkonstruktionen/Handgolfbahn/Bildschirmfoto 2024-01-26 um 22.43.49.png",
      "/Sonderkonstruktionen/Handgolfbahn/Bildschirmfoto 2024-01-29 um 17.00.42.png",
      "/Sonderkonstruktionen/Handgolfbahn/Bildschirmfoto 2024-01-29 um 17.00.58.png",
      "/Sonderkonstruktionen/Handgolfbahn/Bildschirmfoto 2024-01-29 um 17.01.07.png",
    ],
    kunstaktionGraz: [
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.43.42.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.43.32.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.54.55.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.55.04.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.55.11.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.55.22.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.55.29.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.55.39.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.55.46.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.56.01.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.56.23.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.56.36.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.56.48.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.57.06.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.57.29.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.57.41.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.58.00.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.58.44.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.58.53.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 21.59.27.png",
      "/Sonderkonstruktionen/Kunstaktion/Bildschirmfoto 2024-09-27 um 22.00.50.png",
    ],
    milka: [
      "/Sonderkonstruktionen/Milka/1.png",
      "/Sonderkonstruktionen/Milka/Bildschirmfoto 2020-05-26 um 14.54.43.png",
      "/Sonderkonstruktionen/Milka/Bildschirmfoto 2020-05-26 um 14.57.41.png",
      "/Sonderkonstruktionen/Milka/Bildschirmfoto 2020-05-26 um 14.58.06.png",
      "/Sonderkonstruktionen/Milka/Bildschirmfoto 2020-05-26 um 14.58.27.png",
      "/Sonderkonstruktionen/Milka/Bildschirmfoto 2020-05-26 um 14.58.51.png",
      "/Sonderkonstruktionen/Milka/Bildschirmfoto 2024-04-11 um 11.14.20.png",
    ],
    blueMorpho: [
      "/Sonderkonstruktionen/Schmetterling/1.jpeg",
      "/Sonderkonstruktionen/Schmetterling/2.jpg",
      "/Sonderkonstruktionen/Schmetterling/3.jpg",
      "/Sonderkonstruktionen/Schmetterling/4.jpg",
      "/Sonderkonstruktionen/Schmetterling/5.jpg",
      "/Sonderkonstruktionen/Schmetterling/6.jpg",
      "/Sonderkonstruktionen/Schmetterling/7.jpg",
    ],
    weitereSonderkonstruktionen: [
      "/Sonderkonstruktionen/Weitere/Coca_Cola.jpg",
      "/Sonderkonstruktionen/Weitere/Zalando Wand.png",
      "/Sonderkonstruktionen/Weitere/KunstInstallation Zalando.png",
      "/Sonderkonstruktionen/Weitere/Graeber.png",
      "/Sonderkonstruktionen/Weitere/Graeber2.png",
      "/Sonderkonstruktionen/Weitere/Roemerquelle.png",
      "/Sonderkonstruktionen/Weitere/Roku Gin Flasche.jpg",
      "/Sonderkonstruktionen/Weitere/Szene Schriftzug.png",
      "/Sonderkonstruktionen/Weitere/Hornbach.jpg",
      "/Sonderkonstruktionen/Weitere/bedruckte mobile Holzwand-Trog.png",
      "/Sonderkonstruktionen/Weitere/bedruckte_Holzwand.png",
      "/Sonderkonstruktionen/Weitere/Eislandschaft.png",
      "/Sonderkonstruktionen/Weitere/EL Kabel Leuchtbaum 2.jpg",
      "/Sonderkonstruktionen/Weitere/EL Kabel Leuchtbaum 3.jpg",
      "/Sonderkonstruktionen/Weitere/El Kabel Leuchtbaum.jpg",
      "/Sonderkonstruktionen/Weitere/Fanta.png",
      "/Sonderkonstruktionen/Weitere/Felsen.jpg",
      "/Sonderkonstruktionen/Weitere/Fotostation.png",
      "/Sonderkonstruktionen/Weitere/Geschenk-Werbung.jpg",
      "/Sonderkonstruktionen/Weitere/GeschenkspakertbeghbarSternenkino.png",
      "/Sonderkonstruktionen/Weitere/Golfbahn Hypo.jpg",
      "/Sonderkonstruktionen/Weitere/jaz_hotel.png",
      "/Sonderkonstruktionen/Weitere/aor2.png",
      "/Sonderkonstruktionen/Weitere/aor3.png",
      "/Sonderkonstruktionen/Weitere/aor4.png",
      "/Sonderkonstruktionen/Weitere/aor5.png",
      "/Sonderkonstruktionen/Weitere/aor6.png",
      "/Sonderkonstruktionen/Weitere/aor7.png",
      "/Sonderkonstruktionen/Weitere/aor8.png",
    ],
  },
  Wasser: {
    glaskugel: [
      "/Wasser/Glaskugel/gk1.jpg",
      "/Wasser/Glaskugel/gk2.jpg",
      "/Wasser/Glaskugel/gk3.jpg",
      "/Wasser/Glaskugel/gk4.png",
      "/Wasser/Glaskugel/gk5.jpg",
      "/Wasser/Glaskugel/gk6.jpg",
      "/Wasser/Glaskugel/gk7.jpg",
      "/Wasser/Glaskugel/gk8.jpg",
    ],
    springbrunnen: [
      "/Wasser/Springbrunnen/1.jpg",
      "/Wasser/Springbrunnen/2.jpg",
      "/Wasser/Springbrunnen/3.jpg",
      "/Wasser/Springbrunnen/4.jpg",
    ],
    wassershow: [
      "/Wasser/Wassershow/ws-1.jpg",
      "/Wasser/Wassershow/Wasserfall Large.jpeg",
      "/Wasser/Wassershow/mobiles Becken-Wassershow Schwerin.png",
      "/Wasser/Wassershow/Wasserfall 2 Large.jpeg",
      "/Wasser/Wassershow/Wassershow Aufbau.png",
      "/Wasser/Wassershow/Wassershow Dubai 2.png",
      "/Wasser/Wassershow/Wassershow Dubai 3.png",
      "/Wasser/Wassershow/Wassershow Dubai 4.png",
      "/Wasser/Wassershow/Wassershow Dubai.png",
      "/Wasser/Wassershow/Wassershow Frankfurt 2.png",
      "/Wasser/Wassershow/Wassershow Frankfurt 3.png",
      "/Wasser/Wassershow/Wassershow Frankfurt.png",
    ],
    wasservorhang: [
      "/Wasser/Wasservorhang/wv-0.JPG",
      "/Wasser/Wasservorhang/wv-2.png",
      "/Wasser/Wasservorhang/wv-1.png",
      "/Wasser/Wasservorhang/wv-3.png",
      "/Wasser/Wasservorhang/wv-4.png",
      "/Wasser/Wasservorhang/wv-5.jpg",
      "/Wasser/Wasservorhang/wv-6.jpg",
      "/Wasser/Wasservorhang/wv-7.jpg",
      "/Wasser/Wasservorhang/wv-8.jpg",
      "/Wasser/Wasservorhang/wv-9.jpg",
      "/Wasser/Wasservorhang/Graphic Wassersvorhang Koeln.png",
      "/Wasser/Wasservorhang/Graphic Wasservorhang 2.png",
      "/Wasser/Wasservorhang/Graphic Wasservorhang.png",
      "/Wasser/Wasservorhang/Graphic Wasservorhang Kooeln 4.png",
      "/Wasser/Wasservorhang/Graphic Wasservorhang Wien.png",
      "/Wasser/Wasservorhang/Wasservorhang Aufbau.jpg",
      "/Wasser/Wasservorhang/begehbarer Wasservorhang.png",
    ],
    wasserwand: [
      "/Wasser/Wasserwand/ww-1.jpg",
      "/Wasser/Wasserwand/ww-2.jpg",
      "/Wasser/Wasserwand/ww-3.jpg",
      "/Wasser/Wasserwand/ww-4.jpg",
      "/Wasser/Wasserwand/ww-5.png",
      "/Wasser/Wasserwand/ww-6.png",
      "/Wasser/Wasserwand/ww-7.jpg",
      "/Wasser/Wasserwand/ww-8.jpg",
      "/Wasser/Wasserwand/ww-9.png",
    ],
  },
};
export const gallery = [
  {
    img: "/Sonderkonstruktionen/Schmetterling/1.jpeg",
    parallaxSpeed: 0.065,
  },
  {
    img: "/Licht/feuerschalen/fs-4.jpg",
    parallaxSpeed: 0.05,
  },
  {
    img: "/Gestaltungen/Konzerte_Festivals/Frequency/Bildschirmfoto 2022-10-14 um 12.18.37.png",
    parallaxSpeed: 0.08,
  },
  {
    img: "/Licht/Lichterweg/IMG_8413.jpg",
    parallaxSpeed: 0.1,
  },
  {
    img: "/Projektionen/Mapping/mapping1.jpg",
    parallaxSpeed: 0.07,
  },
  {
    img: "/Gestaltungen/Container/IMG_1189.jpeg",
    parallaxSpeed: 0.085,
  },
  {
    img: "/Licht/Lichterketten/lk-8.png",
    parallaxSpeed: 0.06,
  },
  {
    img: "/Licht/ballon_kegel/bk-6.png",
    parallaxSpeed: 0.04,
  },
];
